/**
 * Chart.js set-up for the dashboard: the chart types the tabs use, and the
 * portal's own text colour and font. A tab imports this file once, then draws
 * with react-chartjs-2.
 */
import {
  Chart,
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  DoughnutController,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js';
import { ND_COLORS } from './theme';

Chart.register(
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  DoughnutController,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Tooltip
);

Chart.defaults.color = ND_COLORS.textFaint;
Chart.defaults.borderColor = 'rgba(31, 31, 31, 0.08)';
// The same family as `--font-sans`. A canvas cannot read a CSS variable, so the name is written out.
Chart.defaults.font.family =
  "'Metropolis', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

export { Chart };
